var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUae(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_49",
    "data-name": "Layer 49"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4 38h56v12h-56z",
    transform: "matrix(-1 0 0 -1 64 88)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4 26h56v12h-56z",
    fill: "#fff",
    transform: "matrix(-1 0 0 -1 64 64)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4 14h56v12h-56z",
    fill: "#090",
    transform: "matrix(-1 0 0 -1 64 40)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4 14h15.5v36h-15.5z",
    fill: "#f00",
    transform: "matrix(-1 0 0 -1 23.5 64)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUae);
export default __webpack_public_path__ + "static/media/UAE.0cccc8dc7205b61f930458ba74087b9e.svg";
export { ForwardRef as ReactComponent };